// client/src/lib/socket.ts
import { io, Socket } from 'socket.io-client';
import { SOCKET_URL, SOCKET_PATH } from './env';

export function createSocket(): Socket {
  return io(SOCKET_URL, {
    path: SOCKET_PATH,          // '/socket.io'
    transports: ['websocket'],  // no polling in prod
    withCredentials: false,
    autoConnect: true,
  });
}

// Legacy export for backward compatibility
export const socket = createSocket();